

























































import Vue, { PropType } from 'vue';
// import { buyerWorkKindOptions, OptionValue } from '@/modules/options';
import { options } from 'mostra';

export default Vue.extend({
  name: 'GChatBuyerInfoPc',
  props: {
    company: {
      type: String as PropType<string>,
      default: '',
    },
    department: {
      type: String as PropType<string>,
      default: '',
    },
    name: {
      type: String as PropType<string>,
      default: '',
    },
    shop: {
      type: String as PropType<string>,
      default: '',
    },
    zip: {
      type: String as PropType<string>,
      default: '',
    },
    province: {
      type: String as PropType<string>,
      default: '',
    },
    city: {
      type: String as PropType<string>,
      default: '',
    },
    address: {
      type: String as PropType<string>,
      default: '',
    },
    building: {
      type: String as PropType<string>,
      default: '',
    },
    website: {
      type: String as PropType<string>,
      default: '',
    },
    workKinds: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    introduction: {
      type: String as PropType<string>,
      default: '',
    },
  },
  methods: {
    displayWorkKinds() {
      return options
        .gets(options.buyerWorkKindOptions, this.workKinds)
        .map((o) => this.$t(o.text))
        .join('/');
      // const workKindTexts = this.workKinds.map((val: number) => {
      //   const workKind: OptionValue | undefined = options.buyerWorkKindOptions.find(
      //     (option) => option.value === val,
      //   );
      //   if (!workKind) return '';
      //   return workKind.text;
      // });
      // return workKindTexts.join(',');
    },
  },
});
